<template>
  <question-base-wrapper v-bind="baseWrapperProps">
    <checkbox-square
      v-model="questionData[questionFields.driverPassPlus]"
      class="mb-4"
      name="driver-pass-plus"
      data-test="driver_pass_plus"
    >
      Pass Plus Scheme
    </checkbox-square>
    <checkbox-square
      v-model="questionData[questionFields.advancedMotorist]"
      class="mb-4"
      name="advanced-motorist"
      data-test="advanced_motorist"
    >
      Advanced Driving Test
    </checkbox-square>
    <checkbox-square
      v-model="isDrivingQualificationsModel"
      name="driving-qualifications"
      data-test="driving_qualifications"
    >
      No
    </checkbox-square>
  </question-base-wrapper>
</template>

<script>
import QuestionBase from './Base';
import QuestionBaseWrapper from './BaseWrapper';

export default {
  name: 'question-driving-qualifications',
  extends: QuestionBase,
  components: {
    QuestionBaseWrapper,
  },
  data () {
    return {
      fields: {
        driverPassPlus: 'driverPassPlus',
        advancedMotorist: 'advancedMotorist',
      },
    };
  },
  computed: {
    isDrivingQualificationsModel: {
      get () {
        return !this.questionData[this.questionFields.driverPassPlus] && !this.questionData[this.questionFields.advancedMotorist];
      },
      set () {
        this.questionData[this.questionFields.driverPassPlus] = false;
        this.questionData[this.questionFields.advancedMotorist] = false;
      },
    },
  },
};
</script>
